import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, " H: " + _toDisplayString(_ctx.chance?.heads ?? 0) + "% / T: " + _toDisplayString(_ctx.chance?.tails ?? 0) + "% ", 1))
}